import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Result } from 'antd';
import { setHeader, setRoutes } from 'src/core/ui/shell';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  setHeader(t('Not Found'));
  setRoutes([]);
  return (
    <Result
      status="404"
      title="404"
      subTitle={t('PageDoesNotExists')}
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          {t('BackHome')}
        </Button>
      }
    />
  );
};

export default NotFoundPage;
